import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { apiUrl } from '../../common/models/utils/constants';

const AuthPage = () => {
  const loc = useLocation();

  useLayoutEffect(() => {
    location.replace(loc.state ?? `${apiUrl}/auth/auth0/logout`);
  }, []);

  return <div style={{ color: 'transparent' }}>Go to login</div>;
};

export default AuthPage;
